export type RecaptchaMessages = {
  recaptchaNotAvailable: string;
  recaptchaVerificationFailed: string;
  recaptchaError: string;
  recaptchaNetworkError: string;
  recaptchaTokenGenerationFailed: string;
  recaptchaSiteKeyMissing: string;
  recaptchaScoreTooLow: string;
  recaptchaUnknownError: string;
  recaptchaInvalidToken: string;
  recaptchaUnexpectedFormat: string;
};

export const RECAPTCHA_MESSAGES: RecaptchaMessages = {
  recaptchaNotAvailable: "reCAPTCHA não está disponível no momento. Tente recarregar a página.",
  recaptchaVerificationFailed: "Falha na verificação do reCAPTCHA. Tente novamente.",
  recaptchaError: "Erro durante a verificação do reCAPTCHA.",
  recaptchaNetworkError:
    "Erro de conexão durante a verificação do reCAPTCHA. Verifique sua internet.",
  recaptchaTokenGenerationFailed: "Não foi possível gerar o token reCAPTCHA. Tente novamente.",
  recaptchaSiteKeyMissing: "Chave do site reCAPTCHA não configurada.",
  recaptchaScoreTooLow: "Verificação de segurança falhada. Por favor, tente novamente.",
  recaptchaUnknownError:
    "Erro desconhecido no reCAPTCHA. Entre em contato com o suporte se persistir.",
  recaptchaInvalidToken: "Token reCAPTCHA inválido ou ausente.",
  recaptchaUnexpectedFormat: "Formato de token reCAPTCHA inesperado.",
};
